export default {
  methods: {
    /** Review exclusivity by component */
    isComponentExclusive(currentComponent = this.activeComponent) {
      const exclusiveComponent = this.$store.state.swatches.exclusiveComponents[currentComponent];

      return exclusiveComponent && !!exclusiveComponent.length;
    },

    /** Apply swatch in exclusive component if swatch is not allowed **/
    applySwatchInExclusiveComponent({ currentComponent, swatch, group, subgroup }) {
      if (this.isComponentExclusive(currentComponent)) {
        const exclusiveSwatches = this.$store.state.swatches.exclusiveSwatches[currentComponent];

        if (exclusiveSwatches instanceof Array && exclusiveSwatches.includes(Number(swatch.id))) {
          this.$eventBus.$emit("show-tool-tip-exclusive-comp");
          this.$store.state.swatches.exclusiveComponents[currentComponent].forEach((component) => {
            this.applySwatch(component, swatch.id, this.pdm.components[component].component_configuration_group)
              .then(() => {
                const data = { swatchId: swatch.id, group, subgroup, edited: true };
                this.$store.commit("swatches/SET_SWATCHES_SELECTED", { component: component, data });
                this.$store.commit("swatches/SET_TABS_SELECTED", { component: component, tab: group });
                if(this.$store.state.utils.configuration.enableFlyOutMenu) {
                  this.$store.commit("standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION", { item: {id: component, isChecked: true }});
                } else {
                  this.$store.commit("legacyNavigation/UPDATE_MENU_ITEM_STATE", { componentName: component });
                }
              });
          });
          this.$eventBus.$emit("blockRelationSwatches");
        }
      }
    },

    getSwatchRelationBySwatchId({ currentComponent, swatchId }) {
      return this.$store.dispatch('swatches/GET_RELATION_SWATCH_BY_SWATCH', swatchId)
        .then(response => this.$nextTick(() => {
          // Set onbeforeunload event
          this.$eventBus.$emit('set-onbeforeunload', true);
          // updates tabs
          this.$eventBus.$emit('block-features-by-swatch-id');

          if (this.isComponentExclusive(currentComponent)) {
            const exclusiveData = {
              component: currentComponent,
              components: this.$store.getters['swatches/getRestrictedComponents']({
                object: response,
                activeComponent: currentComponent,
              }),
            };

            this.$store.commit('swatches/SET_EXCLUSIVE_COMPONENTS', exclusiveData);
          }

          this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'swatches', status: false });

          return Promise.resolve(response);
        }));
    },

    /**
     * @function blockExclusiveSwatchesbyPrecreated
     * @param {String} recipeId - Recipe Id
     * Block Exclusive Swatches by Precreated recipe
     */
    blockSwatchesByPrecreated(recipeId) {
      this.$store.dispatch('swatches/GET_RELATION_SWATCH_BY_RECIPE_ID', recipeId)
        .then((response) => {
          const { components } = this.recipe_v2;
          const { swatches_not_allowed } = response;

          Object.keys(components).forEach((component) => {
            if (component !== this.activeComponent) {
              this.$store.commit('swatches/SET_EXCLUSIVE_SWATCHES', {
                swatches: swatches_not_allowed,
                component,
              });
            }
          });
          this.$nextTick(() => this.$eventBus.$emit('block-features-by-precreated-recipe', response));
        })
        .catch(err => console.error(err));
    },
    /**
     * @function applyExclusivitybyDefaultComponent
     * @param {String} recipeId - Recipe Id
     * Apply Exclusive by default component from the pdm
     */
    applyExclusivitybyDefaultComponent(applyUndo = false) {
      return new Promise((resolve) => {
          const { default_component } = this.$store.state.utils.pdm;
          const defaultComponent = this.recipe_v2.components[default_component];
          const swatchObj = this.$store.getters["swatches/returnSwatchObj"]({ swatchId: defaultComponent.swatch_id});
          const data = {
            currentComponent: default_component,
            group: defaultComponent.group,
            swatch: swatchObj,
            subgroup: defaultComponent.subgroup,
            ugcswatchgroup : swatchObj?.ugc_swatch_group
          };
          this.updateSwatchesData(data, applyUndo).then(resolve);
      });
    }
  },
};
